<section class="nav-item">
  <!-- notif icon  -->
  <button
    class="menu-icon"
    mat-icon-button
    [matMenuTriggerFor]="notification"
    aria-label="Example icon-button with a menu"
    (click)="seenNotifications()"
    *ngIf="notifications"
  >
    <div
      *ngIf="unSeenCount > 0 && !isSeen"
      class="notif-badge rounded-circle"
    >
      <p class="notif-badge-hover">{{ unSeenCount }}</p>
    </div>
    <morva-icons icon="notification" nbTooltip="اعلان‌ها" nbTooltipPlacement="bottom"></morva-icons>
  </button>

  <ngx-skeleton-loader class="mt-2"
                       [theme]="{'background-color': '#C4C4C4', width: '25px', height: '25px'}" count="1"
                       appearance="circle" *ngIf="!notifications">
  </ngx-skeleton-loader>
  <!-- notif dropdown  -->
  <mat-menu #notification="matMenu" class="notif-card">
    <div *ngIf="notifications" class="notification-container">
      <nb-card
        class="notifications"
      >
        <nb-card-header class="header"> اعلان‌های شما </nb-card-header>
        <nb-card-body>
          <!-- If an unseen notify exists -->
          <nb-list *ngIf="notifications.length > 0">
            <nb-list-item
              *ngFor="let notify of notifications"
              class="d-flex align-items-start"
            >
              <div class="unseen" *ngIf="!notify.seen"></div>
              <div class="seen" *ngIf="notify.seen"></div>
              <div class="items">
                <p class="p-1st">{{ notify.title }}</p>
                <p class="p-2nd">{{ notify.creationTickTime | dateAgo}}</p>
                <p class="p-3rd">{{ notify.messageContent }}</p>
              </div>
              <div
                class="remove-notif"
                (click)="deleteNotification(notify.notificationId, $event)"
              >
                <morva-icons icon="close"></morva-icons>
              </div>
            </nb-list-item>
          </nb-list>
          <!-- If no unseen notify exists -->
          <div
            *ngIf="notifications.length === 0"
            class="d-flex flex-column text-center no-notif"
          >
            <div class="d-flex justify-content-center px-5 pt-5">
              <morva-icons class="icon-100 icon-opacity-50" icon="notification"></morva-icons>
            </div>
            <p class="no-notify-message pt-3 pb-5">هیچ اعلانی برای شما وجود ندارد.</p>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
  </mat-menu>
</section>
